import { Injectable, inject } from '@angular/core';
import { QuoteRequiredData } from '../models/quote.required.data';
import { DataLoader } from './data.loader';

@Injectable({
  providedIn: 'root',
})
export class SysConfigService {
  private dataLoader = inject(DataLoader);

  requiredData: QuoteRequiredData;
  constructor() {
    this.requiredData = this.dataLoader.getRequiredData();
  }

  includeBankPolicyFeeInHeadToHead() {
    // console.log('this.requiredData.IncludeBankPolicyFeeInHeadToHead=', this.requiredData.IncludeBankPolicyFeeInHeadToHead);
    return this.requiredData.IncludeBankPolicyFeeInHeadToHead;
  }
}
